import { RootState } from "../..";

export const selectList = (state: RootState) => state.countries.data.list;

export const selectIsListLoading = (state: RootState) =>
  state.countries.loading.list;
